module.exports = __webpack_public_path__ + "static/media/HXBJ_28.79ee3c7b.jpg";